import rightImg from "images/travelhero2.png";
import rightImg2 from "images/banner3.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet-async";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { useLanguage } from '../../contexts/languageContext'

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const { language, toggleLanguage } = useLanguage(); // Access language state

  return (
    <>
      {language === 'kr' && (
        <div
          className={`nc-PageAbout overflow-hidden relative ${className}`}
          data-nc-id="PageAbout"
        >

          <Helmet>
            <title>About || NaroSTP</title>
          </Helmet>

          {/* ======== BG GLASS ======== */}
          <BgGlassmorphism />

          <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
            <SectionHero
              rightImg={rightImg2}
              heading=""
              btnText=""
              subHeading="우주 테마파크의 조성 및 운영, 우주 교육, 그리고 인하우스 R&D를 통해 뉴스페이스 시대에 걸맞은 새로운 체험과 배움의 장을 제공하고자 합니다. 나로에스티피는 우주를 주제로 한 다감각형, 몰입형 콘텐츠 개발에 주력하며, 누구나 우주를 향한 질문을 던지고, 답을 찾아갈 수 있는 플랫폼을 지향합니다."
            />

            <SectionFounder />
            <div className="relative py-16">
              <BackgroundSection />
              <SectionClientSay uniqueClassName="PageAbout_" />
            </div>

            {/* <SectionStatistic /> */}

            {/* <SectionSubscribe2 /> */}
          </div>
        </div>
      )}

      {language === 'en' && (
        <div
          className={`nc-PageAbout overflow-hidden relative ${className}`}
          data-nc-id="PageAbout"
        >

          <Helmet>
            <title>About || NaroSTP</title>
          </Helmet>

          {/* ======== BG GLASS ======== */}
          <BgGlassmorphism />

          <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
            <SectionHero
              rightImg={rightImg}
              heading="👋 About Us."
              btnText=""
              subHeading="We're a crew of space dreamers on a mission to render unforgettable, galaxy-inspired adventures! From designing stellar space-themed parks/complexes to managing day-to-day operations, we’re all about creating places where we dare to imagine, we enjoy learning and most importantly, having fun. Our goal? To spark joy, curiosity, and awe in every visitor. Through groundbreaking ideas, unforgettable storytellings and the latest technology, we’re here to make every moment a launchpad for imagination."
            />

            <SectionFounder />
            <div className="relative py-16">
              <BackgroundSection />
              <SectionClientSay uniqueClassName="PageAbout_" />
            </div>

            {/* <SectionStatistic /> */}

            {/* <SectionSubscribe2 /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default PageAbout;
